import UnitePartnerBlockView from './View';

export const UnitePartnerBlockEdit = (props) => {
  return <UnitePartnerBlockView {...props} />;
};

export default UnitePartnerBlockEdit;
